import {Injectable} from '@angular/core';
import {ReplaySubject} from 'rxjs';

declare let marmoset: any;

@Injectable({
    providedIn: 'root',
})
export class MarmosetService {
    public ready: ReplaySubject<HTMLElement>;
    private viewer: any;
    private params;

    constructor() {
        this.ready = new ReplaySubject<HTMLElement>();
        this.viewer = null;
        this.params = {
            width: 512,
            height: 512,
            autoStart: true,
            fullFrame: true,
        };
    }
    load(url: string) {
        if (this.viewer === null) {
            marmoset.transparentBackground = true;
            this.viewer = marmoset.embed(url, this.params);
            this.viewer.onLoad = () => {
                this.ready.next(this.viewer.domRoot);
            };
        } else {
            this.viewer.loadScene(url);
        }
    }
    hide() {
        if (this.viewer !== null) {
        }
    }
}
